'use client';

import mikaService from '@/_service/mika.service';
import { useQuery } from '@tanstack/react-query';
import YourOrders from '../YourOrders';
import Section from './section';
import { IRedux } from '@/_store/types';
import { useSelector } from 'react-redux';
import { FEATURED_BRANDS } from '@/_utils/Constants';
import type { ICategory } from '@/_types';
import type { IProduct } from '@/entities/product/model/types';

export default function Products({
  initialCategories,
  initialSectionProducts,
}: {
  initialCategories?: ICategory[];
  initialSectionProducts?: Record<
    string,
    { products: IProduct[]; count: number }
  >;
}) {
  const menuId = useSelector(
    (state: IRedux) =>
      state.common.branches[FEATURED_BRANDS['yaponamama']]?.menu_id,
  );

  const { data } = useQuery({
    queryKey: ['categories-for-main-page', menuId],
    queryFn: () =>
      mikaService.getCategoryList({ page: 1, limit: 50, menu_id: menuId }),
    initialData:
      !menuId && initialCategories
        ? ({ data: { categories: initialCategories } } as any)
        : undefined,
  });

  const categories: ICategory[] =
    data?.data?.categories ?? initialCategories ?? [];
  const partOne = categories.slice(0, 2);
  const partTwo = categories.slice(2, 50);

  return (
    <>
      {partOne.map((category: ICategory) => (
        <Section
          key={category.id}
          category={category}
          initialProducts={initialSectionProducts?.[category.id]}
        />
      ))}
      <YourOrders />
      {partTwo.map((category: ICategory) => (
        <Section
          key={category.id}
          category={category}
          initialProducts={initialSectionProducts?.[category.id]}
        />
      ))}
    </>
  );
}
